import Swiper from 'swiper/bundle';

export const textScroller = () => {
  function setAlignFullCssVar() {
    // Create the measurement node
    let scrollDiv = document.createElement('div');
    scrollDiv.className = 'scrollbar-measure';
    document.body.appendChild(scrollDiv);

    // Get the scrollbar width & half width
    let scrollBarWidth = window.innerWidth - scrollDiv.clientWidth;
    let alignFullOffset = scrollBarWidth / 2;

    console.log(window.innerWidth);
    console.log(scrollDiv.clientWidth);
    console.warn(scrollBarWidth); // Mac:  15

    // Delete the DIV
    document.body.removeChild(scrollDiv);

    //Get .alignfull element
    let root = document.documentElement;
    let root_style = getComputedStyle(root);

    //Set --alignfull-offset css var
    let cssVarAlignFullOffset =
      root_style.getPropertyValue('--alignfull-offset');
    if (alignFullOffset + 'px' !== cssVarAlignFullOffset) {
      root.style.setProperty('--alignfull-offset', alignFullOffset + 'px');
    }
  }

  //gallery sliders
  document.querySelectorAll('.wp-block-text-scroller').forEach((block, i) => {
    const lastSlide =
      block.querySelector('.swiper-wrapper').children.length - 1;
    console.log(lastSlide);

    new Swiper(block, {
      loop: true,
      slidesPerView: 'auto',
      direction: 'vertical',
      // spaceBetween: 16,
      allowTouchMove: false,
      autoplay: {
        delay: 3000,
        reverseDirection: true,
      },
      initialSlide: lastSlide,
      autoHeight: true,
    });
  });
};
